import { useEffect, useState } from 'react';
import Loader from './common/Loader';


function NotificationItem({notification}) {
  const isViewed = notification?.viewed === true;
  const [isExpanded, setIsExpanded] = useState(false);

  function ToggleExpand() {
    setIsExpanded(prevState => !prevState);
  }

  return (
    <div
      className="m-3 p-3 product-in-cart position-relative"
      style={{ minHeight: '160px', height: 'auto' }}
      tabIndex={0}
      onClick={ToggleExpand}
      aria-expanded={isExpanded}
    >
      <div className="d-flex justify-content-between align-items-start">
        <div className="pe-3 pb-4">
          <h6>{notification.type_display}</h6>
          <div className="mt-3 mb-3" style={isExpanded ? undefined : {display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden'}}>
            <small>{notification.text}</small>
          </div>
        </div>
        <div className="ms-3">
          {isViewed ? (
            <span className="badge text-bg-secondary">Прочитано</span>
          ) : (
            <span className="badge text-bg-danger">Новое</span>
          )}
        </div>
      </div>
      <small className="position-absolute bottom-0 start-0 m-3 mt-5 text-muted">
        <strong>{notification.date_created}</strong>
      </small>
    </div>
  );
}


function UserNotifications({notifications, onOpen, loading}) {
  const notificationsList = Array.isArray(notifications) ? notifications : [];
  
  useEffect(() => {
    onOpen(notificationsList);

  }, [onOpen, notificationsList]);

  return loading ? (
    <Loader/>
  ) : (
    <>
      <div className="row">
        <h3 className="m-3">Уведомления</h3>
      </div>
      <div className="row">
        {notificationsList.length ? (
          <div className="col-xxl-8 col-10">
            {notificationsList.map(notification => (
              <NotificationItem
                key={notification.id}
                notification={notification}
              />
            ))}
          </div>
        ) : (
          <div className="col-xxl-8 col-10">
            <p className="m-5 text-center">У вас пока нет уведомлений</p>
          </div>
        )}
      </div>
    </>
  );
}

export default UserNotifications;
